import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M1 8a.98.98 0 0 1 .475-.844l9.005-5.509a1 1 0 0 1 1.52.845v11.016a.99.99 0 0 1-1.016.992 1 1 0 0 1-.504-.147L1.475 8.845A.98.98 0 0 1 1 8"
    }, null, -1)
  ])))
}
export default { render: render }